/**
 * Arquivo responsavel por manipular as variaveis de ambiente.
 */
import { API_CONFIG } from './config'

/**
 * Retorna a URL base da API com base no ambiente atual.
 * @returns {string} URL base da API
 */
function getBaseUrl() {
    return API_CONFIG.baseUrl
}

const BASE_URL = getBaseUrl()

export { BASE_URL }
